import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useAppointmentActions() {
  const [isLoading, setLoading] = useState(false);

  const confirm = useCallback((appointmentId) => {
    setLoading(true);
    return quarkusApi
      .post(`/appointments/${appointmentId}/confirm`, {}, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const perform = useCallback((appointmentId) => {
    setLoading(true);
    return quarkusApi
      .post(`/appointments/${appointmentId}/perform`, {}, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const cancel = useCallback((appointmentId, reason = null) => {
    setLoading(true);
    return quarkusApi
      .post(`/appointments/${appointmentId}/cancel`, { reason }, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const noShow = useCallback((appointmentId) => {
    setLoading(true);
    return quarkusApi
      .post(`/appointments/${appointmentId}/no-show`, {}, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const reactivate = useCallback((appointmentId) => {
    setLoading(true);
    return quarkusApi
      .post(`/appointments/${appointmentId}/reactivate`, {}, authHeader())
      .finally(() => setLoading(false));
  }, []);

  const remove = useCallback((appointmentId) => {
    setLoading(true);
    return quarkusApi
      .delete(`/appointments/${appointmentId}`, authHeader())
      .finally(() => setLoading(false));
  }, []);

  return { confirm, perform, cancel, noShow, reactivate, remove, isLoading };
}
